/**
 * Lesbare Meldung aus einem fehlgeschlagenen HTTP-Aufruf ziehen.
 *
 * Der globale ErrorInterceptor (src/app/_helpers/error.interceptor.ts) reicht
 * Fehler bereits als String weiter und sammelt dabei die Rails-Validierungs-
 * meldungen aus { attribut: [meldungen] } ein — bewusst ohne Attribut-Präfix,
 * weil die Meldungen im Backend als vollständige Sätze formuliert sind.
 * Das Objekt-Handling bleibt als Absicherung, falls einmal ein Original-Fehler
 * am Interceptor vorbei durchgereicht wird.
 */
export function httpErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === 'string' && error.trim().length > 0) return error

  const data = (error as { error?: unknown })?.error
  if (data && typeof data === 'object') {
    const parts = Object.entries(data as Record<string, unknown>)
      .filter(([, msgs]) => Array.isArray(msgs))
      .map(([, msgs]) => (msgs as string[]).join(', '))
    if (parts.length > 0) return parts.join(' — ')
  }

  return fallback
}
